export default {
  integer: "Bitte geben Sie eine ganze Zahl ein",
  dataType: "Das Feld besitzt nicht den benötigen Datentyp.",
  maxLength: "Das Feld darf maximal {field.maxLength} Zeichen lang sein.",
  minLength: "Das Feld muss mindestens {field.minLength} Zeichen lang sein.",
  maxLowerMin: "Der Wert muss größer als der Minimalwert sein.",
  minHigherMax: "Der Wert muss kleiner oder gleich dem Maximalwert sein.",
  required: "Dies ist ein Pflichtfeld",
  hasNoSwitchingOperation: "Schaltvorgang ist nicht erlaubt",
};
